<template>
    <template v-if="!$store.state.waitingRequest">
        <p v-show="alert.length" :key="alertId" class="popup-message" :style="[alert[0] == 0 ? {'background-color': '#e74c3c'} : {'background-color': '#26a65b'}]">{{ alert[1] }}</p>

        <main>
            <h1>Connexion à mon compte</h1>
            <p v-if="accountCreated" class="account-created">Ton compte a été créé, connecte-toi dès maintenant !</p>
            
            <section class="login">
                <form action="" method="POST" @submit.prevent="validation">
                    <p v-if="pseudoError">{{ pseudoError }}</p>
                    <input type="text" placeholder="Ton pseudo" :value="pseudo" @input="pseudo= $event.target.value" @focus="pseudoErrors" @keyup="pseudoErrors" :class="{ border: pseudoError }" />

                    <p v-if="passwordError">{{ passwordError }}</p>
                    <input type="password" placeholder="Ton mot de passe" :value="password" @input="password= $event.target.value" @focus="passwordErrors" @keyup="passwordErrors" :class="{ border: passwordError }" />

                    <input type="text" placeholder="Autre (laisser vide)" :value="autre" @input="autre= $event.target.value" class="autre" autocomplete="false" />
                    
                    <input type="submit" value="Je me connecte !">
                    
                    <a href="#">J'ai oublié mon mot de passe</a>
                    <router-link to="/register">Je ne suis pas encore inscrit(e)</router-link>
                </form>
                <div class="summary">
                    <h2>Profite d'avantages exclusifs !</h2>
                    <ul>
                        <li><i class="fas fa-cloud-download-alt"></i> Sauvegarde tes données</li>
                        <li><i class="fas fa-users"></i> Fais-toi des amis</li>
                        <li><i class="fas fa-trophy"></i> Récompenses exclusives</li>
                    </ul>
                    
                    <p>Améliore ton expérience de jeu en devenant un(e) membre de Games™.</p>
                    <p>Promis, nous ne te submergerons pas de mails.</p>
                </div>
            </section>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </template>
    <template v-else>
        <SkeletonCategorie />
    </template>
</template>

<script>
import SkeletonCategorie from '../components/SkeletonCategorie.vue';
import AddGoogleScripts from '../mixins/addGoogleScripts';

export default {
    name: 'Login',
    mixins: [AddGoogleScripts],
    components: {
        SkeletonCategorie
    },
    data() {
        return {
            pseudo: '',
            password: '',
            autre: '',

            pseudoError: '',
            passwordError: '',

            alert: [],
            alertId: 0,

            accountCreated: false,

            metas : {
                title: "ClickTestCPS Games™ - Connexion à mon compte",
                meta: [
                    {
                        name: 'description',
                        content: 'Connectez-vous à votre compte Games™ pour profiter dès maintenant de vos avantages !'
                    },
                    {
                        name: 'keywords',
                        content: 'ClickTestCPS, ClickTestCPS.fr, Compte games clicktestcps, ctcps games, ClickTestCPS games, login ClickTestCPS games, se connecter games clicktestcps, ClickTestCPS connexion, click test cps page connexion, inscription click test cps'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);
        this.$store.commit('setRequestTrue');
        this.checkAccountCreated();
        this.checkSession();
    },
    methods: {
        checkAccountCreated() {
            if(this.$store.state.accountCreated) {
                this.accountCreated = true;
                this.$store.commit('setAccountCreated', false);
            } else {
                this.accountCreated = false;
            }
        },
        checkSession() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({ post: "1" }));

            axios
            .post(this.$store.state.apiUrl+"?request=checkSession", formData, { withCredentials: true })
            .then((response) => {
                if(response.data) {
                    this.$router.replace({ name: 'userPanel' });
                }
            }).finally(() => { this.$store.commit('setRequestFalse') });
        },
        pseudoValid() {
            let valid = false;
            
            if (this.pseudo.trim()) {
                valid = true;
            }
            return valid;
        },
        passwordValid() {
            let valid = false;

            if (this.password.trim()) {
                valid = true;
            }
            return valid;
        },
        pseudoErrors() {
            this.pseudoError = '';

            if (!this.pseudoValid()) {
                this.pseudoError = 'Le pseudo est requis.';
            }
        },
        passwordErrors() {
            this.passwordError = '';

            if (!this.passwordValid()) {
                this.passwordError = "Le mot de passe est requis.";
            }
        },
        validation() {
            if (this.pseudoValid() && this.passwordValid() && !this.autre) {
                this.loginAccount();
            } else {
                this.pseudoErrors();
                this.passwordErrors();
            }
        },
        loginAccount() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                login: this.pseudo,
                password: this.password
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=loginAccount", formData, { withCredentials: true })
            .then((response) => {
                if(response.data.id) {
                    this.$router.replace({ name: 'userPanel' });
                }
                else {
                    this.alert = ['0', 'Les identifiants sont incorrects.'];
                    this.alertId++;
                }
            });
        }
    }
}
</script>

<style scoped src="@/assets/register.css">
</style>